import ProductCategoryPage from "../components/ProductCategoryPage.js";

export default function BeigeImportedMarble() {
  return (
    <ProductCategoryPage
      category="Beige"
      seoTitle="Top Beige Imported Marble Collection in Kishangarh India | Best Italian Beige Marble"
      seoDescription="Elegant beige imported marble slabs for timeless interiors & luxury projects."
      canonical="https://www.squarefeetmarble.com/beige-imported-marble-kishangarh.webp"
    />
  );
}
